
  import ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1440,
    "xs": 320
  },
  "presets": {
    "card-list-logo": {
      "modifiers": {
        "width": 64,
        "height": 64
      }
    },
    "product-detail-logo": {
      "modifiers": {
        "width": 100,
        "height": 100
      }
    },
    "detail-page-image": {
      "modifiers": {
        "width": 260,
        "height": 200
      }
    }
  },
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
    }
  }
